import { useSession } from '@/entities/session'

export const useCheckAuth = () => {
	const { currentSession } = useSession()

	return {
		isAuthorized: !!currentSession.token,
		authToken: currentSession.token
	}
}
